import AuthenticatedUser from "@/modules/account/authenticated-user.model";
import AuthenticatedUserProvider from "@/modules/account/authenticated-user-provider.service";

import Upgrade from "./upgrade.model";

export default class UpgradeLabelResolverService {
  constructor(private fAuthenticatedUserProvider: AuthenticatedUserProvider) {}

  public resolve(upgrade: Upgrade): string {
    const user = this.fAuthenticatedUserProvider.getUser();
    const factoryTitle = upgrade.factoryTitle?.trim();

    if (user?.role === AuthenticatedUser.ROLE_FACTORY && factoryTitle) {
      return factoryTitle;
    }

    return upgrade.name;
  }
}
